import api from './client'

export type OnboardingStepKey = 'add_account' | 'log_transaction' | 'set_budget' | 'invite_family'

export interface OnboardingStep {
  key: OnboardingStepKey
  /** Server-provided label, so it stays in one place. */
  title: string
  /** Derived from the household's data — has an account, a transaction, a budget, ≥2 members. */
  done: boolean
  /** This user chose to skip it. */
  skipped: boolean
}

export interface OnboardingState {
  steps: OnboardingStep[]
  dismissed: boolean
}

export function fetchOnboarding(): Promise<OnboardingState> {
  return api.get('/onboarding').then((r) => r.data)
}

/** Exactly one of `skip` (a step key) or `dismiss: true`. Returns the refreshed state. */
export function updateOnboarding(
  change: { skip: OnboardingStepKey } | { dismiss: true }
): Promise<OnboardingState> {
  return api.patch('/onboarding', change).then((r) => r.data)
}
